// src/langurage/zh.js 
// 定义中文语言包对象
export default {
  button: {
    add: '新增',
    delete: '删除',
    edit: '编辑',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    back: '返回',
    search: '查询',
    refresh: '刷新',
    addor:'新增模块',
    reset:'重置',
    MergeIssue:'合并下发',


    issue:'下发',
    signFor:'签收',
    delete:'删除',
    details:'详情',
    point:'指货',
    photos:'拍照'
  },
  radio:{
    shipment:'发货',
    delivery:'收货',
    total:'全部'
  },
  form:{
    startTime:'开始时间',
    endTime:'结束时间',
    BusinessType:'业务类型',
    DeliveryOrder:'交货单号查询',
    VehicleLicense:'车牌号查询',
    DriverName:'司机姓名查询'
  },
  columns: {
    name: '姓名',
    company: '公司',
    address: '地址',
    phone: '电话',
  },
    navigateBar: {
      hotspot: '热点',
      experience: '经验',
      focus: '关注',
      recommend: '推荐'
    },
    tabs: {
      work: '作品',
      private: '私密',
      collect: '收藏',
      like: '喜欢'
    },
    taskDeliveryPlaceholder:{
      selectStartTime:'请选择开始时间',
      SelectEndtime:'请选择结束时间',
      deliveryOrder:'请输入交货单号',
      licensePlate:'请输入车牌号',
      drivername:'请输入司机姓名',
    },
    taskDeliverycolumns: {
      Serial:'序号',
      DeliveryOrder:'交货单号',
      WaybillNumber:'物流单号',
      LicensePlate:'车牌号',
      DriverName:'司机姓名',
      Remarks:'备注',
      WarehouseOrder:'仓储单号',
      CreationTime:'创建时间',
      BusinessType:'业务类型',
      Status:'状态',
      Operation:'操作'
    },
  }